import DialogRenderer from './DialogRenderer';

export default DialogRenderer;
